import React from 'react';

import './visits.css';

const Visits = () => {
    return <div className='block-content' />
};

export default Visits;
